<template>
  <div class="result-card-list">
    <div class="result-card-list__header">Namn</div>
    <div v-if="store.searchResult?.results != null && store.searchResult.results.length > 0">
      <ul v-if="!noVisibleColumns" class="result-card-list__items">
        <ResultCard
          v-for="hit in store.displayedResults"
          :key="hit.uuid"
          :result="hit"
          :columnConfig="columnConfig" />
      </ul>

      <div v-else class="result-card-list__message">
        Du måste välja minst en kolumn för att visa sökresultat.
      </div>

      <div class="result-card-list__bottom">
        <div class="result-card-list__displayed-results">
          <strong>{{ store.displayedResults.length }}</strong> av {{ store.searchResult?.results.length }} träffar
        </div>
        <Pagination :page-window-size="2" />
      </div>
    </div>

    <div v-else class="result-card-list__message">
      Inget resultat hittades
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { columnConfig, IColumnItem } from '@/interfaces/search/IQueryColumn';
import { useStore } from "@/stores/store";

import Pagination from '@/components/pagination/Pagination.vue';
import ResultCard from '@/components/resultcard/ResultCard.vue';

const store = useStore();

const noVisibleColumns = computed(() => {
  return Object.values(columnConfig).every((config: IColumnItem) => !config.visible);
});
</script>
